export default {
  advance_payments: [],
  companies: []
}